export default __webpack_public_path__ + "assets/images/495ea7f5e69317bc22f288e801b0062f.svg";